<template>
  <section class="container-sarah">
    <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="true" />
    <breadcrumb route="/inicio" :title="this.$t('areas.home')" />
    <!-- Intro Text -->
    <div class="hero">
      <div class="hero-body">
        <h1 class="title">
          {{ $t('cirurgias.titulo') }}
        </h1>
        <p class="info_subtitle">
          {{ $t('cirurgias.subtitulo') }}
        </p>
      </div>
    </div>
    <!-- table of content -->
    <div class="table">
      <div
        v-if="solicitacoesCirurgia.length === 0"
        class="container-sarah no-data"
      >
        <div class="img-container">
          <img
            src="~@/assets/images/banners/doctors_calendar.svg"
            alt="Solicitações de cirurgia"
          />
        </div>
        <h1 class="title">
          {{ $t('cirurgias.sem-soliticacoes.titulo') }}
        </h1>
        <h2 class="subtitle">
          {{ $t('cirurgias.sem-soliticacoes.subtitulo') }}
        </h2>
      </div>
      <div v-else>
        <b-table
          :data="solicitacoesCirurgia"
          :loading="isLoading"
          :paginated="isPaginated"
          :checkable="false"
          :checked-rows.sync="solicitacoesCirurgiaSelecionados"
          :current-page.sync="currentPage"
          :per-page="perPage"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :aria-page-label="this.$t('tabelas.pagina')"
          :aria-current-label="this.$t('tabelas.pagina-atual')"
        >
          <template slot-scope="columns">
            <b-table-column
              field="Data da solicitação"
              label="Data da solicitação"
            >
              {{ columns.row.DtHrSolicitacao | formatarDataSolicitacao }}
            </b-table-column>
            <b-table-column field="Programa" label="Programa">
              {{ columns.row.DsPrograma }}
            </b-table-column>
            <b-table-column field="Situação" label="Situação">
              <!-- STATUS: AGENDADA -->
              <b-tag
                class="is-success"
                v-if="columns.row.StatusCirurgia.toUpperCase() === 'AGENDADO'"
              >
                {{ columns.row.StatusCirurgia }}
              </b-tag>
              <!-- STATUS: NA FILA DE ESPERA -->
              <b-tag
                v-else-if="
                  columns.row.StatusCirurgia.toUpperCase() ===
                  'NA FILA DE ESPERA'
                "
              >
                <i class="icon-ic_clock" /> {{ columns.row.StatusCirurgia }}
              </b-tag>
              <!-- STATUS: NAO ESPECIFICADO -->
              <b-tag class="is-info" v-else>
                {{ columns.row.StatusCirurgia }}
              </b-tag>
            </b-table-column>
            <b-table-column field="Unidade" label="Unidade">
              {{ columns.row.DsUnidade }}
            </b-table-column>
            <b-table-column field="Confirmar" label="Ações" class="actions">
              <b-button
                class="action-item-positive margin-mobile"
                @click="visualizarStatusDaSolicitacao(columns.row)"
              >
                {{ $t('botoes.verificar-situacao') }}
              </b-button>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
    <status-cirurgia-modal
      v-if="abrirModalStatusCirurgia"
      :toggle.sync="abrirModalStatusCirurgia"
      :cirurgia="cirurgiaSelecionada"
    />
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { SET_LOADING } from '@/store/modules/mutation-types'
import router from '@/router'
import Breadcrumb from '../../components/shared/breadcrumb/Breadcrumb'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'
import StatusCirurgiaModal from '../../components/shared/modal/StatusCirurgia/StatusCirurgiaModal'
import { format } from 'date-fns'
import CirurgiaService from '@/services/cirurgia-service'

export default {
  name: 'Cirurgias',
  components: {
    Breadcrumb,
    StatusCirurgiaModal
  },

  data() {
    return {
      mostrarConfirmacao: false,
      mostrarJustificativaAusencia: false,
      isPaginated: false,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      currentPage: 1,
      perPage: 10,
      solicitacoesCirurgiaSelecionados: [],
      abrirModalStatusCirurgia: false,
      cirurgiaSelecionada: null,
      loading: false
    }
  },

  beforeMount() {
    this.VerificarUsuario()
  },

  computed: {
    ...mapGetters({
      solicitacoesCirurgia: 'solicitacoesCirurgia',
      solicitacaoCirurgia: 'solicitacaoCirurgia',
      isLoading: 'isLoading',
      paciente: 'dadosPaciente'
    })
  },

  mounted() {
    this.getSolicitacoesCirurgia().catch((err) => {
      if (err instanceof NotAuthenticatedError) router.push('/')
    })
  },

  methods: {
    ...mapMutations([SET_LOADING]),
    ...mapActions(['getSolicitacoesCirurgia', 'getSolicitacaoCirurgia']),
    VerificarUsuario() {
      if (this.paciente == null) {
        router.push({ path: '/', query: { returnUrl: this.$route.path } })
      }
    },
    async visualizarStatusDaSolicitacao(cirurgia) {
      this.loading = true
      await CirurgiaService.getSituacoesDaSolicitacao(cirurgia.DtHrSolicitacao)
      await this.getSolicitacaoCirurgia(cirurgia)
      this.cirurgiaSelecionada = this.solicitacaoCirurgia
      this.loading = false
      this.abrirModalStatusCirurgia = true
    }
  },
  filters: {
    formatarDataSolicitacao(value) {
      if (!value) return ''
      return format(new Date(value), 'dd/MM/yyyy')
    }
  }
}
</script>

<style
  lang="scss"
  scoped
  src="@/assets/stylesheets/views/cirurgias/Cirurgias.scss"
></style>
